import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompCushionsMoto({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')
  const [infoCushions, setInfoCompCushions] = useState({
    Cloth_Seats: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'CC', data: infoCushions });
  });

  const handleForm = ({ target }) => {
    const tmpinfoCushions = { ...infoCushions, [target.name]: target.value }
    setInfoCompCushions(tmpinfoCushions);
    autosave.schedule();
    //generalUpdate('infoCushions', tmpinfoCushions)
  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get(`/peritaje/infostate/C`, {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data;
      const currentDefaultState = stateapp.find((e) => e.name.toLowerCase() === 'bueno')
      setInfoCompCushions({
        Cloth_Seats: currentDefaultState.id,
      });
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { type: 'CC', data: infoCushions };
    const respo = await post('/peritaje/modifyinspection/components/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'CC' };
      const tmpCushions = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const { detail } = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpCushions[element.name] = element.id_state;
        }
        if (detail.length > 0) setInfoCompCushions(tmpCushions);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner /> : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">COJINERIAS</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Cloth_Seats">ASIENTO/SILLIN</Form.Label>
          <Form.Select
            name="Cloth_Seats"
            value={infoCushions.Cloth_Seats}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompCushionsMoto;
